import * as styled from "./OurStudents.styled.jsx";
import { ageGroups } from "../../../helpers/ageGroups.js";
import { useNavigate } from "react-router-dom";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled.jsx";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle.jsx";
import LastStudentCard from "../../../components/LastStudentCard/LastStudentCard.jsx";
import StudentsByDate from "../../../components/StudentsByDate/StudentsByDate.jsx";

function OurStudents() {
  const navigate = useNavigate();

  const groupItemClick = (groupItem) => {
    navigate(`${groupItem}`);
  };

 

 

  return (
    <PagesWrapper>
      <TopPageTitle value={"Наші учні"} />
      <styled.TopWrapper>
        <LastStudentCard />
        <styled.Button onClick={() => navigate("/admin/paused-students")}>Учні на паузі</styled.Button>
      </styled.TopWrapper>
     
      <styled.GroupList>
         <styled.GroupItem onClick={() => navigate('/admin/all-students')}>
            <styled.GroupTitle>Усі учні</styled.GroupTitle>
          </styled.GroupItem>
        {ageGroups.map(({ name, value }) => (
          <styled.GroupItem key={value} onClick={() => groupItemClick(value)}>
            <styled.GroupTitle>{name}</styled.GroupTitle>
          </styled.GroupItem>
        ))}
       
      </styled.GroupList>

      <StudentsByDate route={"students/by-date"}/>

      
    </PagesWrapper>
  );
}

export default OurStudents;
